import React, { useState, } from "react";
import { Link } from "react-router-dom";
import validator from "validator";
import { forgotPwd } from "../../services/ApiServices";
import toast from "react-hot-toast";
import logo from '../../assets/img/logo.png'

const ForgotPassword = ({ setOpenForgotPwd, setOpenOTP, email, setEmail, setForgotEmailId }: any) => {
    // const [email, setEmail] = useState<string>("");

    const [isLoading, setIsLoading] = useState(false);
    const validation = (e: any) => {
        e.preventDefault();
        if (!email) {
            toast.error("Email is required")
            return;
        }
        if (email && !validator.isEmail(email)) {
            toast.error("Please enter a valid email")
            return;
        }
        forgotPwdApiCall()
    }

    const forgotPwdApiCall = () => {
        setIsLoading(true);
        forgotPwd({ email }).then((res) => {
            console.log("forgot password", res);
            if (res.status === "success") {
                setForgotEmailId(email)
                setIsLoading(false);
                toast.success(res.message)
                setEmail("");
                setOpenOTP(true);
                setOpenForgotPwd(false);
            } else if (res.status === "error") {
                setIsLoading(false);
                toast.error(res.message)
            }
        }).catch((err) => {
            setIsLoading(false);
            console.log("forgot password error", err);
            toast.error("something went wrong");
        })
    }
    return (
        <>
            <div className="card border-0 rounded-4">

                <div className="simple-form">
                    <div className="form-header text-center mb-5">
                        <h4 className="fs-2">Forgot Password</h4>

                        <div className="effco-logo mb-2">
                            <Link className="d-flex align-items-center justify-content-center" to="/">
                                <img src={logo} height={50} width={"40%"} />
                            </Link>
                        </div>
                    </div>
                    <form>
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className="form-group mb-3">
                                    <label className='mb-2'>Email</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="john.smith@commercialspc.com"
                                        value={email}
                                        name='email'
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <button
                                type="submit"
                                className="btn btn-primary full-width fw-medium"
                                onClick={(e) => validation(e)}
                                disabled={isLoading}
                            >{isLoading ? "Sending..." : <>Send OTP <i className="fa-solid fa-arrow-right-long ms-2"></i></>}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
};

export default ForgotPassword;
